import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Decorative } from "@faire/design-tokens";
import { HeroSection } from "@faire/retailer-visitor-shared/views/careers/__internal__/components/HeroSection";
import { ViewOpeningsButton } from "@faire/retailer-visitor-shared/views/careers/ViewOpeningsButton";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";
import styled from "styled-components";
var IMAGES = [
    "https://cdn.faire.com/fastly/dfbccf2f0862fdd386cabdcb3973171f2b9df34f227fb5a40c493ee413b9a98b.png",
    "https://cdn.faire.com/fastly/5f9bfc9088849100279d2997bc7455d5aec798ce0ce344d4ff7dcdc6323da027.png",
    "https://cdn.faire.com/fastly/ef73f15846d4761110e6fbb220738924182ebc334919e50665ac3571c90f935f.png",
    "https://cdn.faire.com/fastly/bb9f7102e976e8f09824e187f8ba42d35a27ed4a2bf887d48598076fdc4e0bcc.png",
    "https://cdn.faire.com/fastly/3bbfdf1cafad740c1d05cfec2bc1e174713969baaf5ed14fd7fff9bdb115c32d.png",
    "https://cdn.faire.com/fastly/070dde03b511a074a7fc1a62d8c6b76d8552e490a9bd3b92f3a1aecd88b2c0fa.png"
];
export var LandingPageHeroSection = function(param) {
    var openingsCount = param.openingsCount, isLoading = param.isLoading;
    var strictLocalize = useStrictLocalization().strictLocalize;
    var isDesktopAndAbove = useViewport().isDesktopAndAbove;
    var headerText = strictLocalize({
        id: "F/y/sE",
        defaultMessage: [
            {
                type: 0,
                value: "Help us empower brands and retailers to strengthen the unique character of local communities"
            }
        ]
    });
    var eyebrowText = strictLocalize({
        id: "yHkH8n",
        defaultMessage: [
            {
                type: 0,
                value: "Life At Faire"
            }
        ]
    });
    return /*#__PURE__*/ _jsxs(HeroSection, {
        eyebrowText: eyebrowText,
        heroImages: IMAGES,
        backgroundColor: Decorative.tint.neutral,
        children: [
            /*#__PURE__*/ _jsx(HeaderMinWidthTypography, {
                variant: {
                    mobileAndAbove: "displaySSerifRegular",
                    desktopAndAbove: "displayMSerifRegular"
                },
                children: headerText
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: isDesktopAndAbove ? "4x" : "3x"
            }),
            /*#__PURE__*/ _jsx(HiddenLoadingTypography, {
                $isLoading: isLoading,
                variant: {
                    mobileAndAbove: "paragraphSansRegular",
                    desktopAndAbove: "subheadingSansMedium"
                },
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "toEeX5",
                    defaultMessage: [
                        {
                            type: 1,
                            value: "openingsCountNumber"
                        },
                        {
                            type: 0,
                            value: " openings to join the team"
                        }
                    ],
                    values: {
                        openingsCountNumber: openingsCount
                    }
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                size: isDesktopAndAbove ? "3x" : "2x"
            }),
            /*#__PURE__*/ _jsx(ViewOpeningsButton, {})
        ]
    });
};
var HeaderMinWidthTypography = styled(Typography).withConfig({
    componentId: "sc-1fb128d1-0"
})([
    "",
    "{min-width:424px;}"
], responsiveMediaQueries.xLargeAndAbove);
var HiddenLoadingTypography = styled(Typography).withConfig({
    componentId: "sc-1fb128d1-1"
})([
    "visibility:",
    ";"
], function(props) {
    return props.$isLoading ? "hidden" : "visible";
});
